module.exports = {"TXTCLI_Available":{"id":"TXTCLI_Available","defaultMessage":"使用可"},"TXTCLI_Expires":{"id":"TXTCLI_Expires","defaultMessage":"有効期限"}}